<template>
    <div class="ticket">
        <no-data v-if="dataLoaded&&tickets.length===0" :content-height="contentHeight"></no-data>
        <van-list v-else v-model="loading" :finished="finished" @load="getTickets">
            <van-panel v-for="(ticket,index) in tickets" :key="index" :title="ticket.ticketCode" :status="ticket.statusName" class="margin-bottom-10">
            <van-cell-group>
                <van-cell title="有效期" >
                    <span>{{ticket.startDate}}</span>
                    <span v-if="ticket.endDate!==ticket.startDate">至{{ticket.endDate}}</span>
                </van-cell>
                <van-cell title="登记时间" :value="ticket.cTime" />
            </van-cell-group>
            <div class="ticket-qrcode">
                <img :src="ticket.qrcode" />
            </div>
        </van-panel>
        </van-list>
    </div>
</template>

<script>
import QRCode from "qrcode";
import ticketService from "@/services/ticketService.js";
import NoData from "@/components/NoData.vue";

export default {
  components: {
    NoData
  },
  data() {
    return {
      loading: false,
      dataLoaded: false,
      finished: false,
      queryInput: {
        skipCount: 0,
        maxResultCount: 10
      },
      tickets: []
    };
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 46;
    }
  },
  methods: {
    async getTickets() {
      try {
        this.loading = true;
        this.dataLoaded = false;

        let result = await ticketService.getMemberTicketsForMobileAsync(
          this.queryInput
        );
        for (let i = 0; i < result.items.length; i++) {
          let ticket = result.items[i];
          ticket.qrcode = await this.generateQRCode(ticket.ticketCode);
          this.tickets.push(ticket);
        }

        this.queryInput.skipCount =
          this.queryInput.skipCount + result.items.length;

        this.finished = this.tickets.length === result.totalCount;
      } catch (err) {
        return;
      } finally {
        this.loading = false;
        this.dataLoaded = true;
      }
    },
    async generateQRCode(text) {
      try {
        return await QRCode.toDataURL(text, { width: 200 });
      } catch (err) {
        this.$toast(err);
      }
    }
  }
};
</script>

<style lang="scss">
.ticket {
  &-qrcode {
    width: 100%;
    text-align: center;
  }
}
</style>
